import React from 'react';
import {
  makeStyles,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import { colorSet } from '@components/Provider';
import { CustomizedButton } from '@components/Customized';

const useStyles = makeStyles(() => ({
  paper: {
    margin: '28px 24px'
  },
  text: {
    fontSize: '14px',
    fontWeight: 'normal',
    wordBreak: 'keep-all',
    color: 'rgba(0, 0, 0, 0.6)'
  },
  buttonDelete: {
    color: colorSet.errorMain
  }
}));

interface Props {
  open: boolean;
  text: string;
  onDelete: () => void;
  onClose?: () => void;
}

const DeletePresenter: React.FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <Dialog
      onClose={props.onClose}
      open={props.open}
      classes={{ paper: classes.paper }}
    >
      <DialogContent>
        <DialogContentText classes={{ root: classes.text }}>
          {props.text}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <CustomizedButton
          size="small"
          variant="text"
          onClick={props.onDelete}
          classes={{ root: classes.buttonDelete }}
        >
          삭제
        </CustomizedButton>
        <CustomizedButton
          size="small"
          variant="text"
          color="default"
          onClick={props.onClose}
        >
          취소
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePresenter;
